import { createApp } from 'vue'
import App from './App.vue'
import router from "./router";

import { county_logo } from './api/index';

const setFavicon = () => {
    const link = document.querySelector("link[rel~='icon']") || document.createElement("link");
    link.rel = "shortcut icon";
    link.href = county_logo;
    document.head.appendChild(link);
};

// Set favicon on app startup
setFavicon();



createApp(App)
    .use(router)
    .mount('#app')


